/** Used to keep track of whether the user has explicitly set their locale.
 * If they haven't, we can overwrite it with the locale on their user. */
export function useSavedLocale() {
  const explicitLocale = useCookie<Locale>("i18n_explicit_locale")
  return { explicitLocale }
}
